import * as types from './showActionTypes';

export default (
  state = {
    show: {
      name: '',
    },
    error: null,
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case types.GET_SHOW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_SHOW_SUCCESS:
      return {
        ...state,
        loading: false,
        show: action.show,
      };
    case types.GET_SHOW_ERROR:
      return {
        ...state,
        show: {},
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/show/showReducer.js